/* eslint-disable react-hooks/exhaustive-deps */
import DatePicker from "react-datepicker";
import Header from "../../components/Header/Header";
import "./styles.css";
import { useContext, useEffect, useState } from "react";
import AccordionNF from "./components/AccordionNF";
import { Context } from "../../hooks/useAuthContext";
import api from "../../services/axiosConfig";

function MinhasNotasFiscais() {
  const { userData, exibirLogs } = useContext(Context);

  const anoSelecionado = new Date();
  anoSelecionado.setFullYear(anoSelecionado.getFullYear());

  const [selectedDatePeriod, setSelectedDatePeriod] = useState(anoSelecionado);
  const [notasFiscais, setNotasFiscais] = useState([]);

  function formatarMesExtenso(dataString) {
    if (!dataString) return "Mês inválido";
    const partes = dataString.split("/");
    const mes = parseInt(partes[0]) - 1;
    const nomesMeses = [
      "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
    ];
    return nomesMeses[mes] || "Mês inválido";
  }

  const buscarNotasFiscais = async (ano) => {
    try {
      const response = await api.get(`/nf/notas-fiscais`, {
        params: { uid: userData._id, ano },
      });
      setNotasFiscais(response.data);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar notas fiscais:", error);
      throw new Error("Erro ao buscar notas fiscais:", error);
    }
  };

  const handleAnoChange = (date) => {
    setSelectedDatePeriod(date);
  };

  useEffect(() => {
    if (userData?._id) {
      buscarNotasFiscais(selectedDatePeriod.getFullYear());
    }
  }, [selectedDatePeriod, userData]);

  function agruparNotasPorMesEAno(notas) {
    const agrupadas = {};

    notas.forEach((nota) => {
      const dataString = nota.date; 
      if (!dataString || dataString.split('/').length !== 2) {
        return; 
      }

      const [mes, ano] = dataString.split("/");
      const chave = `${ano}-${mes}`;

      if (!agrupadas[chave]) {
        agrupadas[chave] = [];
      }
      agrupadas[chave].push(nota);
    });

    return agrupadas;
  }

  const notasAgrupadas = agruparNotasPorMesEAno(notasFiscais);

  return (
    <div className="contentNf">
      <Header urlFoto="https://i.imgur.com/nCIToeZ.png" />
      <div className="wrapper">
        <h1 className="titleNf">Minhas Notas Fiscais</h1>

        <div style={{ width: "100%" }}>
          <h3 className="cardTitleNf">Selecione o Ano</h3>
          <DatePicker
            selected={selectedDatePeriod}
            onChange={handleAnoChange}
            dateFormat="yyyy"
            className="dateInputNF"
            showYearPicker
            value={`Selecionado - ${selectedDatePeriod.getFullYear()}`}
          />
        </div>

        <div className="accordionList">
          {Object.keys(notasAgrupadas).length === 0 ? (
            <p style={{ color: "white" }}>Nenhuma nota fiscal encontrada!</p>
          ) : (
            Object.entries(notasAgrupadas)
              .sort((a, b) => b[0].localeCompare(a[0])) 
              .map(([chave, notasDoMes]) => {
                const [ano, mes] = chave.split('-').map(Number);

                const primeiroDiaDoMes = new Date(ano, mes - 1, 1);
                primeiroDiaDoMes.setHours(0, 0, 0, 0);

                const ultimoDiaDoMes = new Date(ano, mes, 0);
                ultimoDiaDoMes.setHours(23, 59, 59, 999);
                

                const nomeMes = formatarMesExtenso(notasDoMes[0].date);
                const idAccordion = `accordion-${chave}`;

                return (
                  <AccordionNF
                    key={idAccordion}
                    id={idAccordion}
                    title={nomeMes}
                    notas={notasDoMes}
                    dataInicio={primeiroDiaDoMes.getTime()}
                    dataFim={ultimoDiaDoMes.getTime()}
                    buscarNotasFiscais={() => buscarNotasFiscais(selectedDatePeriod.getFullYear())}
                    selectedDatePeriod={selectedDatePeriod}
                  />
                );
              })
          )}
        </div>
      </div>
    </div>
  );
}

export default MinhasNotasFiscais;